export default __webpack_public_path__ + "static/media/image.0729a9f2.svg";